import React, { useEffect } from 'react';
import { useMeContext } from '~/modules/me/useMeContext';
import { useRepliconAssistantDetection } from './useRepliconAssistantDetection';

export const RepliconAssistant = () => {
  const { featureFlags } = useMeContext();
  const showRepliconAssistant = useRepliconAssistantDetection();

  useEffect(() => {
    if (!showRepliconAssistant) {
      return () => {};
    }

    const script = document.createElement('script');

    script.setAttribute('type', 'module');
    script.setAttribute('src', featureFlags.repliconAssistant);
    script.async = true;

    document.body.append(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [showRepliconAssistant, featureFlags?.repliconAssistant]);

  if (!showRepliconAssistant) {
    return <></>;
  }

  return (
    <>
      <replicon-assistant></replicon-assistant>
    </>
  );
};

export default RepliconAssistant;
